import {VoyageStatusSingleVoyage} from "@containers/singleVoyage/types/voyage";


export const STATUSES_SINGLE_VOYAGES_RUNS: {
    value: VoyageStatusSingleVoyage,
    label: string
}[] = [
    {value: 'READY_FOR_MANUAL_RUN', label: 'singleVoyage.statuses.readyForManualRunSelect'},
    {value: 'PLANNED_FOR_AUTORUN', label: 'singleVoyage.statuses.plannedForAutorunSelect'},

]